import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { theme } from "./theme/theme";
import LandingPage from "./components/LandingPage";
import SimpleApp from "./SimpleApp";
import { initGA, trackPageView } from "./utils/analytics";

function App() {
  useEffect(() => {
    // Initialize Google Analytics
    const GA_TRACKING_ID =
      process.env.REACT_APP_GA_TRACKING_ID || "G-9707KT3SMS";
    initGA(GA_TRACKING_ID);

    // Track initial page view
    trackPageView(window.location.pathname);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/app" element={<SimpleApp />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
